import PropTypes from 'prop-types';

import stylesCommon from '../../Question.scss';

export const ImageOption = ({ displayName, description = '', imageSrc }) => (
  <em className={stylesCommon.OptionsList__option_colour}>
    <img src={imageSrc} alt={displayName} />
    <div>
      <p>{displayName}</p>
      <span>{description}</span>
    </div>
  </em>
);

ImageOption.propTypes = {
  displayName: PropTypes.string.isRequired,
  description: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
};
